import React, { useMemo } from "react";
import { theme } from "uikit";
import styled from "styled-components";

import { SIP } from "../../../../../../../../../../services";
import { useTypedSelector } from "../../../../../../../../../../redux/store";
import Circle from "../../../../../../../../../Circle";
import { StyledRow } from "../../../../../../../../../common";

const Root = styled(StyledRow)`
	cursor: pointer;
`;

const Sip: React.FC<Props> = ({ data }) => {
	const { sipValue } = useTypedSelector((state) => state.sipToDispatcher);

	const circleColor = useMemo(() => {
		if (data.sipValue === sipValue) return "#8000FF";
		// Redis occupancy (instant). Asterisk lastCheckMs lags and stays "free"
		// for hardphones that never JsSIP-register — that made all lamps green.
		return data.occupiedByUserId == null
			? "rgb(76, 175, 80)"
			: theme.colors.negative;
	}, [data.occupiedByUserId, data.sipValue, sipValue]);

	return (
		<Root alignItems="center">
			<Circle color={circleColor} />
		</Root>
	);
};

interface Props {
	data: SIP.Model.Available;
}

export default Sip;
